import { cn } from "../../lib/utils";

interface StepProgressProps {
  /** Total number of steps */
  totalSteps: number;
  /** Current active step (0-indexed) */
  currentStep: number;
  /** Extra class names on the root container */
  className?: string;
  /**
   * `mobile` is the carousel's (Figma O1). `desktop` is the onboarding
   * column's (Figma "D7.identite"): every step reached is a long stride that
   * shares the bar, and only the steps left to do are short.
   */
  variant: "mobile" | "desktop";
}

function StepProgress({
  totalSteps,
  currentStep,
  className,
  variant,
}: StepProgressProps) {
  return (
    <div className={cn("flex gap-1.5 items-center justify-center", className)}>
      {Array.from({ length: totalSteps }, (_, i) => (
        <div
          key={i}
          className={cn(
            "h-0.75 min-w-0 rounded-full transition-all duration-300",
            // Figma O1 (node 4827:8653): the step on screen is one long dark
            // stride, the walked ones are short and pale, the ones left to do
            // are short and grey. The segments shrink together when a long
            // flow does not fit the band.
            variant === "desktop"
              ? i <= currentStep
                ? "flex-1 bg-ds-mint-700"
                : "w-3 shrink-0 bg-ds-slate-200"
              : i === currentStep
                ? "flex-3 max-w-19 bg-ds-mint-700"
                : i < currentStep
                  ? "flex-1 max-w-6 bg-ds-mint-100"
                  : "flex-1 max-w-6 bg-ds-slate-200"
          )}
        />
      ))}
    </div>
  );
}

export { StepProgress, type StepProgressProps };
